import api from './api';
import type {
  OrganizacaoKpisContract,
  OrganizacaoOrganogramaContract,
  OrganizacaoPessoasItemContract,
  OrganizacaoMovimentacaoItemContract,
  OrganizacaoCargoDetalhesContract,
  SalvarCargoSuperiorPayloadContract,
  EfetivarMudancaFuncaoPayloadContract,
  EfetivarMudancaFuncaoResponseContract,
  IniciarMudancaFuncaoComExamePayloadContract,
} from '@sstexames/shared-types';

export const organizacaoService = {
  async getKpis(empresaId?: number): Promise<OrganizacaoKpisContract> {
    const params: Record<string, string | number | undefined> = empresaId ? { empresaId, empresa_id: empresaId } : {};
    const headers: Record<string, string> = empresaId ? { 'x-empresa-id': String(empresaId) } : {};
    const response = await api.get<OrganizacaoKpisContract>('/organizacao/kpis', { params, headers });
    return response.data;
  },

  async getOrganograma(empresaId?: number): Promise<OrganizacaoOrganogramaContract> {
    const params: Record<string, string | number | undefined> = empresaId ? { empresaId, empresa_id: empresaId } : {};
    const headers: Record<string, string> = empresaId ? { 'x-empresa-id': String(empresaId) } : {};
    const response = await api.get<OrganizacaoOrganogramaContract>('/organizacao/organograma', { params, headers });
    return response.data;
  },

  async getPessoas(empresaId?: number, search?: string, setorId?: number): Promise<OrganizacaoPessoasItemContract[]> {
    const params: Record<string, string | number | undefined> = {};
    if (empresaId) {
      params.empresaId = empresaId;
      params.empresa_id = empresaId;
    }
    if (search) params.search = search;
    if (setorId) params.setorId = setorId;
    const headers: Record<string, string> = empresaId ? { 'x-empresa-id': String(empresaId) } : {};
    const response = await api.get<OrganizacaoPessoasItemContract[]>('/organizacao/pessoas', { params, headers });
    return response.data;
  },

  async getMovimentacoes(
    empresaId?: number,
    periodo: 'hoje' | 'semana' | 'mes' | 'ano' | 'tudo' = 'mes',
    search?: string,
    setorId?: number,
    cargoId?: number,
  ): Promise<OrganizacaoMovimentacaoItemContract[]> {
    const params: Record<string, string | number | undefined> = { periodo };
    if (empresaId) {
      params.empresaId = empresaId;
      params.empresa_id = empresaId;
    }
    if (search) params.search = search;
    if (setorId) params.setorId = setorId;
    if (cargoId) params.cargoId = cargoId;
    const headers: Record<string, string> = empresaId ? { 'x-empresa-id': String(empresaId) } : {};
    const response = await api.get<OrganizacaoMovimentacaoItemContract[]>('/organizacao/movimentacoes', { params, headers });
    return response.data;
  },

  async getCargoDetalhes(cargoId: number, empresaId?: number, setorId?: number): Promise<OrganizacaoCargoDetalhesContract> {
    const params: Record<string, string | number | undefined> = {};
    if (empresaId) {
      params.empresaId = empresaId;
      params.empresa_id = empresaId;
    }
    if (setorId) {
      params.setorId = setorId;
      params.setor_id = setorId;
    }
    const headers: Record<string, string> = empresaId ? { 'x-empresa-id': String(empresaId) } : {};
    const response = await api.get<OrganizacaoCargoDetalhesContract>(`/organizacao/cargos/${cargoId}/detalhes`, { params, headers });
    return response.data;
  },

  async salvarCargoSuperior(payload: SalvarCargoSuperiorPayloadContract): Promise<{ success: boolean; message: string }> {
    const headers: Record<string, string> = payload.empresa_id ? { 'x-empresa-id': String(payload.empresa_id) } : {};
    const response = await api.post<{ success: boolean; message: string }>('/organizacao/cargos/hierarquia', payload, { headers });
    return response.data;
  },

  async efetivarMudancaFuncao(
    payload: EfetivarMudancaFuncaoPayloadContract,
  ): Promise<EfetivarMudancaFuncaoResponseContract> {
    const response = await api.post<EfetivarMudancaFuncaoResponseContract>(
      '/organizacao/mudanca-funcao',
      payload,
    );
    return response.data;
  },

  async iniciarMudancaFuncao(
    payload: IniciarMudancaFuncaoComExamePayloadContract,
  ): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(
      '/organizacao/iniciar-mudanca-funcao',
      payload,
    );
    return response.data;
  },
};
